import { useApiHandler } from '@/hooks/useApiHandler'
import { ApiConfig } from '@/types/api'
import { AuthResponse, LoginRequest, RegisterRequest } from '@/types/auth'
import { ApiRoutes } from './apiRoutes'

export function useAuthApi(config?: Partial<ApiConfig>) {
    const api = useApiHandler(ApiRoutes.AUTH, config)

    return {
        login: (data: LoginRequest) =>
            api.post<AuthResponse>('/aspirants/login', data),

        register: (data: RegisterRequest) =>
            api.post<AuthResponse>('aspirants/fast-register', data, { skipAuth: true }),

        refreshToken: (data: {
            oldAccessToken: string
            refreshToken: string
        }) => {
            return api.post<AuthResponse>('/sessions/refresh-token', data)
        },

        logout: (refreshToken: string) =>
            api.post<void>(`/sessions/revoke/${refreshToken}`),

        confirmEmail: (token: string) =>
            api.get<void>(`users/confirm-email?token=${token}`),
        resendConfirmation: (email: string) =>
            api.post<void>(
                `/users/resend-confirmation?email=${encodeURIComponent(email)}`,
                null
            ),
        requestPasswordReset: (email: string) =>
            api.post<void>(
                `/users/initiate-password-change?email=${encodeURIComponent(email)}`,
                null
            ),
        changePassword: (
            token: string,
            newPassword: string,
            passwordConfirmation: string
        ) =>
            api.post<void>('/users/change-password', null, {
                params: {
                    token,
                    newPassword,
                    passwordConfirmation
                }
            }),

        agentLogin: (tokenAccess: string, password: string, idAsesor: number) =>
            api.post<AuthResponse>('/aspirants/spoofing/login', null, {
                params: {
                    tokenAccess,
                    password,
                    idAsesor
                }
            })
    }
}
